<template>
  <div class="bg">
    <img src="../../assets/yunyingimg/fashion/biaoti.png"  class="one_img" />
    <img src="../../assets/yunyingimg/fashion/chanpin.png" class="two_img" />
    <img src="../../assets/yunyingimg/fashion/fangan.png" />
    <img src="../../assets/yunyingimg/fashion/pingtai.png" />
    <div class="car">
      <img src="../../assets/yunyingimg/fashion/car.png" class="car-box" />
    </div>
    <div class="bot">
      <img src="../../assets/yunyingimg/fashion/shili.png" class="bot_box" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.bg {
  width: 100%;
  background: url("../../assets/yunyingimg/fashion/bg.png") no-repeat;
  background-size: 100% 100%;
  text-align: center;
}
.bg .one_img {
  width: 90%;
  margin-top: 45px;
}
.bg .two_img {
  width: 100%;
  margin-top: 20px;
}
.car {
  margin-top: 5px;
  text-align: right;
}
.car-box {
  width: 90%;
}

.bot {
  text-align: left;
}
.bot_box {
  margin-top: 10px;
  margin-bottom: 40px;
  width: 94%;
}
</style>